import { render, staticRenderFns } from "./theGoods.vue?vue&type=template&id=1d17c3fc&scoped=true&"
import script from "./theGoods.vue?vue&type=script&lang=js&"
export * from "./theGoods.vue?vue&type=script&lang=js&"
import style0 from "./theGoods.vue?vue&type=style&index=0&id=1d17c3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d17c3fc",
  null
  
)

export default component.exports